import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './styles.css';

type PropTypes = {
  freezeGameClock: boolean;
  gameClock: number;
  par: number;
  spectate: boolean;
};

export const GameClock = ({
  freezeGameClock,
  par,
  gameClock,
  spectate,
}: PropTypes) => {
  const [timerSnapshot, setTimerSnapshot] = useState(0);

  useEffect(() => {
    if (freezeGameClock && timerSnapshot === 0) {
      setTimerSnapshot(gameClock);
    } else if (!freezeGameClock && timerSnapshot > 0) {
      setTimerSnapshot(0);
    }
  }, [freezeGameClock, gameClock, timerSnapshot]);

  if (spectate) {
    return (
      <Typography
        className={gameClock === par ? 'game-timer-grow' : ''}
        textAlign="center"
        letterSpacing="0.25em"
        variant="h2"
        sx={{
          textShadow: `#fff 0px 0px 0px, #818181 0px 0px 20px, #fff 0px 0px 0px`,
        }}
      >
        00:{gameClock < 10 ? '0' : null}
        {gameClock}
      </Typography>
    );
  }

  return (
    <Typography
      className={gameClock === par ? 'game-timer-grow' : ''}
      textAlign="center"
      letterSpacing="0.25em"
      variant="h2"
      my={1}
      sx={{
        textShadow: `#fff 0px 0px 0px, #fff 0px 0px 20px, #fff 0px 0px 0px`,
      }}
    >
      00:{(freezeGameClock ? timerSnapshot : gameClock) < 10 ? '0' : null}
      {freezeGameClock ? timerSnapshot : gameClock || 0}
    </Typography>
  );
};
